import React from "react";
import "./TermsOfUse.css";
function Content() {
  return (
    <div className="wrap-inner-page tou">
      <div className="container">
        <div className="row">
          <div className="col-12 pt-4">
            <h1 className="inner-title">Terms of Use</h1>
            <p className="inner-para">
              Gato Systems and its subsidiaries (collectively, “Gato Systems”, “us”, “our” or “we”) will use these Terms of
              Use and are in addition to any other agreements between you and
              Gato Systems including any customer or account agreements
              and any other agreements that govern your use of services and
              information provided by Gato Systems.
            </p>
            <h3 className="inner-title-sm">GENERAL</h3>
            <p className="inner-para">
              Gato Systems offers an API platform that gives visitors
              access to real-time trading APIs, customizable fund transfer
              workflows, APIs for onboarding new clients, and global FIX
              connectivity. Through our web app, desktop client, and mobile app,
              users also have access to financial market data for stocks, and
              other financial assets, securities, and other information
              concerning financial markets. Gato Systems is not a
              registered broker-dealer, financial institution, exchange, or
              investment advisor nor does it make any recommendations regarding
              the appropriateness of particular opportunities for any investor.
            </p>

            <h3 className="inner-title-sm">ACCEPTANCE OF TERMS OF USE</h3>
            <p className="inner-para">
              By using the Service and the Content, you agree to follow and be
              bound by these Terms of Use, including the policies referenced
              herein. Customers of Gato Systems are granted additional
              levels of access to the website and their relationship with Gato
              Systems is governed by the terms mentioned in these
              Terms of Use.
            </p>

            <h3 className="inner-title-sm">
              PERSONAL AND NON-COMMERCIAL USAGE
            </h3>
            <p className="inner-para">
              Other than as set forth herein, you agree to use the Services and
              Content solely for your own personal and non-commercial purposes.
              Should you wish to use the Services and Content for any other
              purposes, including without limitation commercial usage, or making
              the Services and Content available to others through your user
              profile, you shall provide Gato Systems with 30 days’
              advance written notice prior to making such access available to
              others. Gato Systems reserves the right to restrict your
              User’s connectivity to the Service and Content and may disallow
              any connectivity entirely if Gato Systems determines the
              User may interfere with Gato Systems’ Services or
              otherwise be detrimental to Gato Systems, as may be
              determined in Gato Systems’ sole discretion.
            </p>

            <h3 className="inner-title-sm">
              DISCLAIMER AND LIMITATIONS OF LIABILITY
            </h3>
            <p className="inner-para">
              The Content and the Service are provided on an “as is” and “as
              available” basis. To the fullest extent permitted under applicable
              law, Gato Systems and the Third-Party Providers expressly
              disclaim all warranties of any kind with respect to the Content
              and the Service, whether express or implied, including, but not
              limited to, the implied warranties of merchantability, fitness for
              a particular purpose and non-infringement. Gato Systems
              nor Third-Party Providers guarantee the accuracy, timeliness,
              completeness, or usefulness of any Content. You agree to use the
              Content and the Service only at your own risk. Neither Gato Systems nor the Third-Party Providers explicitly or
              implicitly endorse or approve any Third-Party Content. Third-Party
              Content is provided for informational purposes only. The Content
              is not intended to provide financial, legal, tax, or investment
              advice or recommendations. Gato Systems AND THE
              THIRD-PARTY PROVIDERS WILL NOT BE LIABLE FOR ANY DIRECT, INDIRECT,
              INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES,
              INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS,
              REVENUE, INCOME, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES
              (EVEN IF Gato Systems OR ANY THIRD PARTY PROVIDER HAS
              BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM:
              (1) THE USE OF OR THE INABILITY TO USE THE CONTENT OR THE SERVICE;
              (2) ACCESS TO OR ALTERATION OF YOUR ACCOUNT, TRANSMISSIONS OR DATA
              DUE TO YOUR CONDUCT, INACTION OR NEGLIGENCE; OR (3) ANY OTHER
              MATTER RELATING TO THE CONTENT OR THE SERVICE.
            </p>

            <h3 className="inner-title-sm">MOBILE SERVICE</h3>
            <p className="inner-para">
              If you are using our mobile application, you are responsible for
              any fees incurred, including data, access, and usage fees by an
              internet provider or mobile carrier, when accessing our Services.
            </p>

            <h3 className="inner-title-sm">NO RECOMMENDATIONS</h3>
            <p className="inner-para">
              Gato Systems does not make recommendations of any kind.
              You are solely responsible for evaluating the merits and risks
              associated with the use of any Content provided through the
              Service before making any decisions based on such Content. You
              agree not to hold Gato Systems liable for any claim for
              damages arising from any decision you make based on the Content or
              other information made available to you through the Service. Past
              performance data should not be construed as indicative of future
              results.
            </p>

            <h3 className="inner-title-sm">CONTENT</h3>
            <p className="inner-para">
              Content posted on the Service is published as of its stated date
              or if no date is stated, the date of first posting. Neither Gato Systems nor the Third-Party Providers have undertaken
              any duty to update any such information. You will not hold Gato Systems
              and/or any Third-Party Provider liable in any
              way for (a) any inaccuracy of, error or delay in, or omission of
              the Content; or (b) any loss or damage arising from or occasioned
              by i) any error or delay in the transmission of such Content; ii)
              interruption in any such Content due either to any negligent act
              or omission by any party to any “force majeure” (e.g., flood,
              extraordinary weather conditions, earthquake or other act of God,
              fire, war, insurrection, riot, labor dispute, accident, the action
              of government, communications or power failure, equipment or
              software malfunction); iii) to any other cause beyond the
              reasonable control of Gato Systems and/or Third-Party
              Provider; or iv) non-performance.
            </p>
            <p className="inner-para">
              Content is provided exclusively for personal and noncommercial
              access and use. No part of the Service or Content may be copied,
              reproduced, republished, uploaded, posted, publicly displayed,
              encoded, translated, transmitted, or distributed in any way
              (including “mirroring”) to any other computer, server, website or
              another medium for publication, distribution or for any commercial
              enterprise, without Gato Systems’s prior written consent.
              You acknowledge that Gato Systems is the sole owner of
              Gato Systems, and its subsidiaries. You agree that you
              will not use any Content or Service for any purpose without the
              prior express written consent of the respective owners.
            </p>

            <h3 className="inner-title-sm">TERMINATION; MODIFICATION</h3>
            <p className="inner-para">
              You agree that, without notice, Gato Systems may
              terminate these Terms of Use or suspend your access to the Service
              or the Content, with or without cause at any time and effective
              immediately. These Terms of Use will terminate immediately without
              notice from Gato Systems if you fail to comply with any
              provision of these Terms of Use. Gato Systems shall not
              be liable to you or any third party for the termination or
              suspension of the Service or the Content, or any claims related to
              such termination or suspension. Gato Systems may also
              terminate or suspend your access to the Service or the Content if
              Gato Systems finds that your usage violates these Terms
              of Use, or if your usage puts an undue strain on Gato Systems,
              LLC’ information technology infrastructure.
            </p>
            <p className="inner-para">
              Gato Systems may discontinue or modify the Content, or
              any portion thereof, at any time. You release and agree to
              indemnify and hold harmless Gato Systems, and the
              Third-Party Providers, for any loss or damages arising from or
              relating to such discontinuation or modification.
            </p>

            <h3 className="inner-title-sm">COMMUNICATIONS</h3>
            <p className="inner-para">
              By using the Service or the Content, you consent to any form of
              recording and retention of any communication, information, and
              data exchanged between you and Gato Systems or its
              representatives or agents. Without limitation, you agree not to do
              any of the following:
            </p>
            <ul className="inner-listing">
              <li>
                upload, post, transmit or otherwise make available any Content
                that is unlawful, harmful, threatening, abusive, harassing,
                tortuous, defamatory, vulgar, obscene, libelous, or invasive of
                another's privacy (including, but not limited to, any address,
                email, phone number, or any other contact information without
                the written consent of the owner of such information), hateful,
                or racially, ethically, or otherwise objectionable
              </li>

              <li>harm minors in any way</li>

              <li>
                impersonate any person or entity, including, but not limited to
                a Gato Systems or Third-Party Provider manager,
                employee, agent, or representative
              </li>

              <li>
                falsely state or otherwise misrepresent your affiliation with
                any person or entity
              </li>

              <li>
                forge headers or otherwise manipulate identifiers to disguise
                the origin of any material
              </li>

              <li>
                upload, post or otherwise transmit any material that you do not
                have a right to send under any law or under contractual or
                fiduciary relationships (such as inside information, proprietary
                and confidential information learned or disclosed as part of
                employment relationships, or under nondisclosure agreements)
              </li>

              <li>
                upload, post, or otherwise transmit any material that infringes
                any patent, trademark, trade secret, copyright, rights of
                privacy or publicity, or other proprietary rights of any party
              </li>

              <li>
                upload, post, or otherwise transmit any material that infringes
                any patent, trademark, trade secret, copyright, rights of
                privacy or publicity, or other proprietary rights of any party
              </li>

              <li>
                upload, post, or transmit unsolicited commercial email or
                “SPAM,” including, but not limited to, unethical marketing,
                advertising, or any other practice that is in any way connected
                with SPAM, such as (1) sending a mass email to recipients who
                haven't requested email from you or with a fake return address;
                (2) promoting a site with inappropriate links, titles, or
                descriptions; or (3) promoting any site by posting multiple
                identical submissions
              </li>

              <li>
                upload, post or otherwise transmit any material that contains
                software viruses, or any other computer code, files or programs
                designed to interrupt, destroy, or limit the functionality of
                any computer software or hardware or telecommunications
                equipment
              </li>

              <li>
                interfere with or disrupt the Service or servers or networks
                connected to the Service, or disobey any requirements,
                procedures, policies, or regulations of networks connected to
                the Service
              </li>

              <li>
                intentionally or unintentionally violate any applicable local,
                state, national or international law, including, but not limited
                to, regulations promulgated by the U.S. Securities and Exchange
                Commission, any rules of any national or other securities
                exchange, and any regulations having the force of law
              </li>

              <li>“stalk” or otherwise harass another</li>

              <li>
                collect or store personal data about other users of the Service
              </li>

              <li>
                promote or provide instructional information about illegal
                activities, promote physical harm or injury against any group or
                individual, or promote any act of cruelty
              </li>

              <li>
                promote, offer for sale, or sell any security or item, good or
                service that i) violates any applicable federal, state, or local
                law or regulation, ii) you do not have full power and authority
                under all relevant laws and regulations to offer and sell,
                including all necessary licenses and authorizations, or iii) Gato
                Systems or the Third-Party Providers determine, in
                their sole discretion, is inappropriate for sale
              </li>
            </ul>

            <h3 className="inner-title-sm">APPLICABLE POLICIES</h3>
            <p className="inner-para">
              In addition to these Terms of Use, your access to and use of the
              Content and the Service is subject to Gato Systems’s most
              current policies relating to the Content and the Service,
              including, without limitation, the Gato Systems Privacy
              Policy available on the Service. You agree to be bound by these
              policies and all other Gato Systems policies applicable
              to the access and use of the Content and the Service.
            </p>
            <p className="inner-para">
              By using the Service, you are consenting to have your personal
              data transferred to and processed by Gato Systems and its
              affiliates. As part of providing, you the Service, Gato Systems may need to provide you with certain
              communications, such as service announcements and administrative
              messages. These communications are considered part of the Service,
              which you may not be able to opt out from receiving.
            </p>

            <h3 className="inner-title-sm">INDEMNIFICATION</h3>
            <p className="inner-para">
              You will indemnify and hold harmless Gato Systems and the
              Third Party Providers, and the officers, directors, agents,
              partners, employees, licensors, distributors, and representatives
              of Gato Systems and the Third Party Providers, from and
              against any and all claims, demands, actions, causes of action,
              suits, proceedings, losses, damages, costs, and expenses,
              including reasonable attorneys' fees, arising from or relating to
              your access and/or use of, or interaction with the Content
              (including, without limitation, Third Party Content), or any act,
              error, or omission of your use of your account or any user of your
              account, in connection therewith, including, but not limited to,
              matters relating to incorrect, incomplete, or misleading
              information; libel; invasion of privacy; infringement of a
              copyright, trade name, trademark, service mark, or other
              intellectual property; any defective product or any injury or
              damage to person or property caused by any products sold or
              otherwise distributed through or in connection with the Service;
              or violation of any applicable law.
            </p>

            <h3 className="inner-title-sm">
              APPLICABLE LAW AND VENUE; SEVERABILITY
            </h3>
            <p className="inner-para">
              You agree that these Terms of Use shall be governed by and
              interpreted in accordance with the laws of the State of New York,
              without giving effect to principles of conflicts of law and you
              hereby irrevocably consent to the personal jurisdiction and venue
              therein. If any provision of these Terms of Use is deemed
              unlawful, void, or for any reason unenforceable, then that
              provision will be deemed severable from these Terms of Use and
              will not affect the validity and enforceability of the remaining
              provisions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Content;
